module.exports = __webpack_public_path__ + "img/02-illu-sweets0226.ded7919a.png";